module.exports = __webpack_public_path__ + "static/mobile-kit-d289b281b46ef7916b83bb8e3acc9675.jpg";